// extracted by mini-css-extract-plugin
export default {"hideTooltip":"h_-z","fadeIn":"i_-z","delay":"j_-z","recommendedSizeTooltip":"k_-z"};